import React, { useState } from "react";
import { submitFeedback } from "../../../services/feedbackService";
import PageHeader from "../../shared/PageHeader/PageHeader";
import "../fyo-shared.css";
import "./FeedbackPage.css";

export default function FeedbackPage() {
  const [firstName, setFirstName] = useState("");
  const [lastName,  setLastName]  = useState("");
  const [email,     setEmail]     = useState("");
  const [message,   setMessage]   = useState("");
  const [submitting,    setSubmitting]    = useState(false);
  const [submitError,   setSubmitError]   = useState<string | null>(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitError(null);
    try {
      await submitFeedback({ first_name: firstName, last_name: lastName, email, message });
      setSubmitSuccess(true);
      setFirstName(""); setLastName(""); setEmail(""); setMessage("");
    } catch (err: any) {
      setSubmitError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const isValid = firstName.trim() && lastName.trim() && email.trim() && message.trim();

  return (
    <div className="fyo-page">
      <PageHeader title="Feedback" />

      {/* ── Submit Form ── */}
      <div className="fyo-card" style={{ marginBottom: "var(--space-4)" }}>
        <h2 className="fyo-section-title">Submit Ohio Talent Track Feedback</h2>

        {submitSuccess && (
          <div className="fb-success-banner">
            ✓ Thank you! Your feedback has been submitted.
          </div>
        )}

        <form onSubmit={handleSubmit} className="fb-form">
          <div className="fb-form__name-row">
            <div className="fb-form__field">
              <label className="fb-form__label">
                First Name <span className="fb-form__required">*</span>
              </label>
              <input
                className="fyo-input"
                value={firstName}
                onChange={(e) => { setFirstName(e.target.value); setSubmitSuccess(false); }}
                placeholder="John"
                required
              />
            </div>
            <div className="fb-form__field">
              <label className="fb-form__label">
                Last Name <span className="fb-form__required">*</span>
              </label>
              <input
                className="fyo-input"
                value={lastName}
                onChange={(e) => { setLastName(e.target.value); setSubmitSuccess(false); }}
                placeholder="Doe"
                required
              />
            </div>
          </div>

          <div className="fb-form__field">
            <label className="fb-form__label">
              Email <span className="fb-form__required">*</span>
            </label>
            <input
              className="fyo-input"
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setSubmitSuccess(false); }}
              placeholder="john@example.com"
              required
            />
          </div>

          <div className="fb-form__field">
            <label className="fb-form__label">
              Message <span className="fb-form__required">*</span>
            </label>
            <textarea
              className="fyo-textarea"
              value={message}
              onChange={(e) => { setMessage(e.target.value); setSubmitSuccess(false); }}
              placeholder="Share your feedback, suggestions, or report an issue..."
              rows={5}
              required
            />
          </div>

          {submitError && <div className="fyo-error-banner">{submitError}</div>}

          <div>
            <button
              type="submit"
              className="fyo-btn fyo-btn--primary"
              disabled={submitting || !isValid}
            >
              {submitting ? "Submitting..." : "Submit Feedback"}
            </button>
          </div>
        </form>
      </div>

      {/* ── Contact Us ── */}
      <div className="fyo-card">
        <h2 className="fyo-section-title">Further Program Discovery</h2>
        <div className="fb-contact-grid">
          <p className="fb-contact-card__desc">
            For questions or support related to the Find Your Ohio program, business process, referral details, or candidates, please contact:
          </p>
          <p className="fb-contact-card__desc">
            For questions or support related to the AI Ready Ohio program, partnership or employer engagement, or program outcomes and reporting, please contact:
          </p>
        </div>

        <div className="fb-contact-divider-grid">
          <hr className="fb-contact-divider" />
          <hr className="fb-contact-divider" />
        </div>

        <div className="fb-contact-grid">
          <div className="fb-contact-info">
            <p className="fb-contact-card__name">Alex Conley</p>
            <p className="fb-contact-card__role">Director, Find Your Ohio</p>
            <p className="fb-contact-card__email">
              <a href="mailto:conley@jobsohio.com">conley@jobsohio.com</a>
            </p>
          </div>
          <div className="fb-contact-info">
            <p className="fb-contact-card__name">Payal Thakur and Team</p>
            <p className="fb-contact-card__role">Managing Director, Data, Analytics & Artificial Intelligence</p>
            <p className="fb-contact-card__role">Data Analytics</p>
            <p className="fb-contact-card__email">
              <a href="mailto:enterprisedata@jobsohio.com">enterprisedata@jobsohio.com</a>
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}
